'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentApplepayAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M25.4565 21.6435C24.8455 22.3753 23.8679 22.9526 22.8904 22.8701C22.7682 21.8805 23.2468 20.8291 23.8068 20.1797C24.4178 19.4272 25.4871 18.8912 26.3526 18.85C26.4545 19.8808 26.0573 20.891 25.4565 21.6435ZM26.3425 23.066C25.4812 23.0158 24.6954 23.3282 24.0606 23.5805C23.6522 23.7428 23.3063 23.8803 23.0431 23.8803C22.7478 23.8803 22.3876 23.7355 21.9832 23.5728C21.4533 23.3598 20.8475 23.1161 20.2122 23.1278C18.756 23.1484 17.4016 23.9834 16.6582 25.3131C15.1308 27.9726 16.2611 31.9103 17.7377 34.075C18.4607 35.147 19.3262 36.3221 20.4668 36.2809C20.9685 36.2617 21.3295 36.1067 21.703 35.9463C22.133 35.7615 22.5798 35.5696 23.2773 35.5696C23.9507 35.5696 24.3779 35.7565 24.788 35.9359C25.1779 36.1065 25.5524 36.2703 26.1082 36.2603C27.2895 36.2397 28.0329 35.1882 28.7559 34.1162C29.5361 32.9656 29.879 31.8427 29.931 31.6723L29.9371 31.6526C29.9359 31.6513 29.9262 31.6469 29.9092 31.639C29.6484 31.5181 27.6548 30.5943 27.6357 28.1169C27.6165 26.0376 29.217 24.984 29.4689 24.8182C29.4842 24.8081 29.4946 24.8013 29.4992 24.7977C28.4809 23.2721 26.8924 23.1072 26.3425 23.066ZM34.5196 36.1469V20.0766H40.4767C43.552 20.0766 45.7007 22.2207 45.7007 25.3544C45.7007 28.488 43.5113 30.6527 40.3953 30.6527H36.9839V36.1469H34.5196ZM36.9839 22.1795H39.825C41.9635 22.1795 43.1855 23.334 43.1855 25.3647C43.1855 27.3954 41.9635 28.5602 39.8148 28.5602H36.9839V22.1795ZM53.8371 34.2193C53.1853 35.4769 51.7495 36.2706 50.2017 36.2706C47.9104 36.2706 46.3117 34.8893 46.3117 32.8071C46.3117 30.7455 47.8595 29.56 50.721 29.3848L53.7963 29.1993V28.3128C53.7963 27.0036 52.9511 26.2924 51.444 26.2924C50.2017 26.2924 49.2954 26.9418 49.1121 27.9314H46.8921C46.9634 25.8491 48.8982 24.3339 51.5153 24.3339C54.336 24.3339 56.169 25.8285 56.169 28.1478V36.1469H53.888V34.2193H53.8371ZM50.8636 34.3636C49.5499 34.3636 48.7149 33.7245 48.7149 32.7452C48.7149 31.735 49.5194 31.1475 51.0571 31.0547L53.7963 30.8795V31.7866C53.7963 33.2916 52.5336 34.3636 50.8636 34.3636ZM63.7351 36.7757C62.7474 39.5898 61.617 40.5175 59.2138 40.5175C59.0305 40.5175 58.4195 40.4969 58.2769 40.4557V38.5281C58.4297 38.5487 58.8065 38.5693 58.9999 38.5693C60.0895 38.5693 60.7005 38.1054 61.0773 36.8994L61.3013 36.1881L57.1262 24.4885H59.7026L62.6048 33.9822H62.6557L65.5579 24.4885H68.063L63.7351 36.7757Z",
          fill: "black"
        }
      )
    ]
  }
);
const VpPaymentApplepayAsset = forwardRef(PaymentApplepayAsset);

export { VpPaymentApplepayAsset as default };
